import type { FieldValue, TableColumns } from '@lighthouse/core'
import type { InsertDirection } from '@lighthouse/shared'
import { getMainTableRecordId } from '@lighthouse/shared'
import type { Getter, Setter } from 'jotai'
import { findIndex, subtract } from 'rambda'

import { currentAppIdAtom } from '../application/state'
import { addRecordAtom, setDsRecordAtom, setRecordsAtom } from './action'
import { dsDependentDataAtomFamily } from './state'
import type { CreateRecordActionPayload, DeleteRecordAtomPayload } from './types'

export const createDsRecordAction = (params: CreateRecordActionPayload, get: Getter, set: Setter) => {
    const appId = get(currentAppIdAtom)
    const { envId, dsId, id, schema } = params
    const content: Record<string, FieldValue> = Object.fromEntries(
        Object.entries(schema).map(([fieldId, config]) => {
            return [
                fieldId,
                {
                    value: ''
                }
            ]
        })
    )
    const newRecord = { content, appId, envId, dsId, id }
    set(addRecordAtom, newRecord)
    set(setDsRecordAtom, {
        identifier: { dsId, viewId: dsId },
        data: draft => {
            draft.recordPoints = [{ id }, ...(draft.recordPoints ?? [])]
            if (draft.rowTotal) {
                draft.rowTotal += 1
            } else {
                draft.rowTotal = 1
            }
        }
    })
}

export const deleteRecordAction = (params: DeleteRecordAtomPayload, get: Getter, set: Setter) => {
    const appId = get(currentAppIdAtom)
    // 解决连接表问题
    const { recordIds, envId, viewId, dsId, mode } = params
    if (!recordIds) {
        return
    }
    const mainRecordIds = new Set(recordIds.map(id => getMainTableRecordId(id)))
    set(dsDependentDataAtomFamily({ dsId, viewId: viewId || dsId }), draft => {
        draft.recordPoints = mode === 'ALL' ? [] : draft.recordPoints.filter(point => !mainRecordIds.has(getMainTableRecordId(point.id)))
        if (draft.rowTotal) {
            draft.rowTotal = mode === 'ALL' ? 0 : subtract(draft.rowTotal, recordIds.length)
        }
    })

    set(setRecordsAtom, {
        records: draft => {
            if (mode === 'ALL') {
                // 删除指定 dsId 的所有记录
                for (const [key, record] of draft.entries()) {
                    if (record.appId === appId && record.dsId === dsId && record.envId === envId) {
                        draft.delete(key)
                    }
                }
                return
            }

            // 删除指定的记录
            for (const [key, record] of draft.entries()) {
                const isEqualRecordId = mainRecordIds.has(getMainTableRecordId(record.id))
                if (record.appId === appId && isEqualRecordId) {
                    draft.delete(key)
                }
            }
        }
    })
}

export const getFieldBeforeId = (tableProps: TableColumns, sourceId: string | undefined, direction: InsertDirection | undefined) => {
    if (!sourceId || !direction) {
        return ''
    }
    const index = findIndex(item => item.id === sourceId, tableProps)
    return direction === 'left' ? sourceId : tableProps[index + 1]?.id
}
